export default function Registartion() {
  let togglePassword = document.querySelectorAll(".reg_password-svg");
  let passLogId = document.querySelectorAll(".toggle_password");

  togglePassword &&
    togglePassword.forEach((item) => {
      item.addEventListener("click", () => {
        const input = passLogId && passLogId;
        for (let i = 0; i < input.length; i++) {
          if (input[i].getAttribute("type") === "password") {
            input[i].setAttribute("type", "text");
          } else {
            input[i].setAttribute("type", "password");
          }
        }
      });
    });
}
